import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["output", "outputwrapper", "heading"]

  show(event) {
    event.preventDefault();

    const container = event.currentTarget

    const imageEl = container.querySelector("[data-image]")
    const nameEl = container.querySelector("[data-name]")
    const typeEl = container.querySelector("[data-type]")
    const descEl = container.querySelector("[data-description]")
    const speakingEls = container.querySelectorAll("[data-speaking-on]")

    if (!imageEl || !nameEl || !descEl) return

    const image = imageEl.dataset.image
    const name = nameEl.dataset.name
    const type = typeEl.dataset.type
    const description = descEl.dataset.description

    const wrapper = document.createElement("div")
    wrapper.className = "d-flex align-items-center"

    const img = document.createElement("img")
    img.src = image
    img.alt = name
    img.className = "img-thumbnail me-4"
    img.style.width = "500px"

    const textWrapper = document.createElement("div")
    textWrapper.className = "ps-3"

    const nameElDisplay = document.createElement("h3")
    nameElDisplay.textContent = name
    nameElDisplay.className = "h3 text-light fw-light mb-1"

    const descElDisplay = document.createElement("div")
    descElDisplay.textContent = description
    descElDisplay.className = "text-light h5 lh-base fw-light"
    descElDisplay.style.opacity = "0.85";

    const badgeWrapper = document.createElement("div")
    speakingEls.forEach(el => {
      const topic = el.dataset.speakingOn
      if (topic) {
        const badge = document.createElement("span")
        badge.textContent = topic
        badge.className = "badge bg-secondary me-1"
        badgeWrapper.appendChild(badge)
      }
    })

    textWrapper.appendChild(nameElDisplay)
    textWrapper.appendChild(descElDisplay)
    textWrapper.appendChild(badgeWrapper)

    wrapper.appendChild(img)
    wrapper.appendChild(textWrapper)

    this.outputTarget.innerHTML = ""
    this.outputTarget.appendChild(wrapper)
    this.outputwrapperTarget.classList.remove('d-none')

    this.headingTarget.innerHTML = `Meet the ${type}`
  }
}
